import { api } from '$app/api'

const removeFalsy = (obj) => {
  let newObj = {};
  Object.keys(obj).forEach((prop) => {
    if (obj[prop]) { newObj[prop] = obj[prop]; }
  });
  return newObj;
};

const garageUserPath = (garageId, userId) =>
  `/garages/${garageId}/users/${encodeURIComponent(userId)}`;

export const listGarageUsers = garageId => api.get(`/garages/${garageId}/users`)
  .then(res => res.data)

export const createGarageAccount = (garageId, template) =>
   api.post(`/garages/${garageId}/users`, removeFalsy(template))
    .then(res => res.data);

export const deleteUser = (garageId, userId) => {
  const user = { userId }

  return api.delete(garageUserPath(garageId, userId), { data: user })
    .then(res => res.data)
}

export const editUser = (garageId, template) => api.patch(garageUserPath(garageId, template.userId), template)
  .then(res => res.data)

export const requestPasswordReset = (garageId, userId) =>
  api.post(`${garageUserPath(garageId, userId)}/password-reset`)
    .then(res => res.data)